export default {
  jobs: 'Jobs',
  message: 'Message',
  approach: 'Approach',
  profile: 'Profile'
}
